<template>
  <div>
    <!-- ヘッダ -->
    <comVFHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="companyName"></comVFHeaderAuth>
    <!-- メイン -->
    <v-main>
      <v-container fluid>
        <!-- データ入力エリア -->
        <v-simple-table class="simple-table">
          <template v-slot:default>
            <tbody>
              <tr v-for="item in desserts" :key="item.name">
                <td class="table-title" >{{ item.name }}</td>
                <td v-if="item.requiredFlg" class="table-title-required">
                  <label class="tbl-lbl-blcok required"></label>
                </td>
                <td v-else class="table-title">
                  <label class="tbl-lbl-blcok"></label>
                </td>
                <td class="table-td-1">
                  <template v-if="!confirmFlg">
                    <template v-if="item.type === 'text'">
                      <v-text-field :label='item.label' :placeholder='item.placeholderChrs' dense solo  v-model="item.inputval"></v-text-field>
                    </template>
                    <!-- <template v-else-if="item.type === 'radio'">
                    <v-radio-group v-model="selectedSex" row class = "ma-0">
                      <v-radio
                        v-for="sex in sexList"
                        :key= sex.cd
                        :label= sex.name
                        :value= sex.cd
                      ></v-radio>
                    </v-radio-group>
                    </template> -->
                    <template v-else-if="item.type === 'check'">
                      <!-- <v-checkbox v-model="item.inputval" class="d-flex align-center justify-start" disabled></v-checkbox> -->
                      <v-checkbox v-model="item.inputval" class="d-flex align-center justify-start"></v-checkbox>
                    </template>
                    <template v-else-if="item.type === 'btn'">
                      <v-btn x-large color="success" dark max-height="35px" class="table-td-btn" @click="pwdChange()">パスワード変更</v-btn>
                    </template>
                    <template v-else-if="item.type === 'calendar'">
                      <v-row class="search-date" no-gutters>
                        <v-col cols="5">
                        <v-menu
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                              v-model="item.inputval"
                              label=""
                              single-line
                              clearable
                              prepend-icon="mdi-calendar"
                              dense
                              solo
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.inputval"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <!-- <v-col cols="2" class="d-flex align-start justify-center mt-3">
                        ～
                      </v-col> -->
                      <!-- <v-col cols="5" class="search-date">
                        <v-menu
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                              v-model="item.inputval"
                              label=""
                              clearable
                              prepend-icon="mdi-calendar"
                              dense
                              solo
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              single-line
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.inputval"
                          ></v-date-picker>
                        </v-menu>
                      </v-col> -->
                    </v-row>
                    </template>
                  </template>

                  <!-- 確認用 -->
                  
                  <template v-else>
                    <template v-if="item.type === 'text'">
                      <v-text-field :label='item.label' :placeholder='item.placeholderChrs' dense solo  v-model="item.inputval" disabled></v-text-field>
                    </template>
                    <template v-else-if="item.type === 'check'">
                      <v-checkbox v-model="item.inputval" class="d-flex align-center justify-start" disabled></v-checkbox>
                    </template>
                    <template v-else-if="item.type === 'btn'">
                      <v-btn x-large color="success" dark max-height="35px" class="table-td-btn" disabled @click="pwdChange()">パスワード変更</v-btn>
                    </template>
                    <template v-else-if="item.type === 'calendar'">
                      <v-row class="search-date" no-gutters>
                        <v-col cols="5">
                        <v-menu
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field 
                              v-model="item.inputval"
                              label=""
                              single-line
                              clearable
                              prepend-icon="mdi-calendar"
                              dense
                              solo
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              disabled
                              
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.inputval"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    </template>
                  </template>
                  
                  <!-- 確認用 -->


                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <br/>
        <!-- ボタンエリア -->
        <v-row justify="end" align-content="end" class="mt-1">
          <template v-if="!this.confirmFlg">
            <v-col cols="12" lg="3" xl="2" class="d-flex align-center justify-end">
              <v-btn x-large color="success" dark min-width="200px" @click="register()">更新</v-btn>
            </v-col>
          </template>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            <v-btn x-large color="success" dark min-width="200px" @click="cancel()">キャンセル</v-btn>
          </v-col>
        </v-row>

      </v-container>
    </v-main>
    
    <!-- フッター(なし) -->

    <!-- その他 -->
    <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
    <comMessage :msg="dlgMsgCompd.msg" :isOpen="dlgMsgCompd.isOpen" :doYes="dlgMsgCompd.doYes"/>
    <comMessage :msg="dlgLogoutMsgCompd.msg" :isOpen="dlgLogoutMsgCompd.isOpen" :doYes="dlgLogoutMsgCompd.doYes"/>
  </div>
</template>

<script>
import Constants from "../common/constantsVf";
import Utils from "../common/utils";
export default {
  name: "VFVerifyUserModify",
  data() {
    return {
      screenTitle: "確認ユーザ更新",
      screenId: "VFU210",
      userName: "",
      companyName: "",
      desserts: [],
      pswdFlg: false,
      password: "Password",
      // checked: false,
      // selectedSex: {},
      // sexList: [{name:"男性", cd:"M"}, {name:"女性", cd:"F"}],
      username: "",
      befUserNo: "",
      befUpdateDatetime: "",
      befUpdateUserId: "",
      confirmFlg: false,
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgCompd.isOpen = false;
          this.$router.push(this.$router.resolve({ name: "VFU100" }).href);
        },
      },
      dlgLogoutMsgCompd: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgLogoutMsgCompd.isOpen = false;
          this.$store.commit("vfAuthcUser/resetState");
          this.$router.push(this.$router.resolve({ name: "VFA100" }).href);
        },
      }
    };
  },
    created() {
    this.initialize();
  },
    methods: {
   /*
    * 初期表示
    */
    initialize: function () {
      this.setAuthUserInfo();
      this.userId = this.$route.params.verifyUserId;
      /* データ表示 */
      this.getVerifyUserInfo(this.userId);
    },
    /*
    * 更新ボタン押下
    */
    register: async function () {
      // 確認ユーザ更新サービス呼び出し
      let responseData = null;
      let apiErrorInfo = null;
      try {
        let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
        let apiurl = Constants.getUrlApiVFU210P01(this.userId);
        // 入力データ
        let data = JSON.stringify(this.createRequestData());
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        responseData = response.data;
        console.log(response);
      } catch(error) {
        apiErrorInfo = error;
      } finally {
        this.loading = false;
      }
      // 完了メッセージ表示
      this.showDialogMsg(apiErrorInfo, responseData);
    },
    /*
    * キャンセルボタン押下
    */
    cancel: function() {
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "VFU100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
   /*
    * ユーザ情報取得
    */
    getVerifyUserInfo : async function(userId) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiVFU210G01(userId);
      let accessToken = this.$store.getters["vfAuthcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        // ユーザ情報表示
        this.displyVerifyUserInfo(response.data);

      } catch(error) {
          this.dlgMsg.msg = this.$i18n.t('msg.err.cm100', ['確認ユーザ']);
          this.dlgMsg.isOpen = true;
          this.desserts.push({});
      } 
    },
    /*
    * 確認ユーザ情報表示
    */
    displyVerifyUserInfo : function(responseData) {
      this.desserts = new Array();
      if (responseData == null) {
        return;
      }
      let user = responseData.data; 
      
      this.desserts.push({ name: "ユーザID", inputval: user.userNo, placeholderChrs: "", type: "text", requiredFlg: true});
      this.desserts.push({ name: "氏名", inputval: user.name, placeholderChrs: "", type: "text", requiredFlg: true});
      this.desserts.push({ name: "氏名（フリガナ）", inputval: user.nameKana, placeholderChrs: "", type: "text", requiredFlg: false});
      this.desserts.push({ name: "メールアドレス", inputval: user.mailAddress, placeholderChrs: "", type: "text", requiredFlg: true});
      this.desserts.push({ name: "メールアドレス（確認）", inputval: user.mailAddress, placeholderChrs: "", type: "text", requiredFlg: true});
      this.desserts.push({ name: "決裁者", inputval: user.approverFlg, placeholderChrs: "", type: "check", requiredFlg: false});
      this.desserts.push({ name: "パスワード", inputval: "", placeholderChrs: "", type: "btn", requiredFlg: false});
      this.desserts.push({ name: "有効期間(開始)", inputval: user.validityperiodStartDate, placeholderChrs: "", type: "calendar", requiredFlg: true});
      this.desserts.push({ name: "有効期間(終了)", inputval: user.validityperiodEndDate, placeholderChrs: "", type: "calendar", requiredFlg: false});

      this.befUserNo = user.userNo;
      this.befUpdateDatetime = user.updateDatetime;
      this.befUpdateUserId = user.updateUserId;
      this.confirmFlg = user.confirmFlg;
    },
    /*
    * 完了メッセージ表示
    */
    showDialogMsg : function(apiErrorInfo, responseData) {
      let hasError = true;
      // APIコール異常
      if (responseData == null || apiErrorInfo != null) {
        this.dlgMsg.msg = this.$i18n.t('msg.err.cm112', ['確認ユーザ']);
        this.dlgMsg.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseData.statusCd === 200) {
        // 処理正常
        hasError = false;
        if (responseData.messageCd === "IVFV012") {
          this.dlgLogoutMsgCompd.msg = responseData.message ;
          this.dlgLogoutMsgCompd.isOpen = true;
        } else {
          this.dlgMsgCompd.msg = responseData.message ;
          this.dlgMsgCompd.isOpen = true;
        }
        return hasError;
      } else {
        // 処理異常
        let errorList = responseData.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
          return hasError;
        }
      }
    },
    /*
    * 登録用リクエストデータ生成
    */
    createRequestData : function() {
      let reqData = {};
      for (const value of this.desserts) {
        switch (value.name) {
         case 'ユーザID':
            reqData['userNo'] = value.inputval;
            break;
          case '氏名':
            reqData['name'] = value.inputval;
            break;
          case '氏名（フリガナ）':
            reqData['nameKana'] = value.inputval;
            break;
          case 'メールアドレス':
            reqData['mailAddress'] = value.inputval;
            break;
          case 'メールアドレス（確認）':
            reqData['mailAddressConfirm'] = value.inputval;
            break;
          case '決裁者':
            reqData['approverFlg'] = value.inputval;
            break;
          case '有効期間(開始)':
            reqData['validityperiodStartDate'] = value.inputval;
            break;
          case '有効期間(終了)':
            reqData['validityperiodEndDate'] = value.inputval;
            break;
        }      
      }
      reqData['befUserNo'] = this.befUserNo;
      reqData['updateDatetime'] = this.befUpdateDatetime;
      reqData['updateUserId'] = this.befUpdateUserId;

      return reqData;
    },
    /*
    * パスワード変更ボタン押下
    */
    pwdChange : function() {
      this.$router.push(this.$router.resolve({ name: "VFU220", params: {verifyUserId: this.userId, srcScreenId: this.screenId }}).href);
    },
    setAuthUserInfo : function() {      
      let authInfo = this.setVerifyLoginInfoVfMixin();
      this.username = authInfo['username'];
      this.companyName = authInfo['companyname'];
    },
  },
}
</script>
<style scoped>
.simple-table {
  table-layout: auto;
  width: 96%;
  margin: 40px 20px;
}
.table-title {
  background-color: #f2f2f2;
  width: 20%;
  font-size: 0.9em !important;
  text-align: left;
}
.table-title-required {
  background-color: #f2f2f2;
  width: 10%;
  text-align: right;
}
.table-td-1 {
  display: flex;
  text-align: left;
  padding: 6px 6px !important;
  background-color: #f2f2f2;
}
</style>